export default __webpack_public_path__ + "static/media/i-vin.6a338be0.svg";